// extracted by mini-css-extract-plugin
export var checkbox = "_7l-0";
export var circle = "_7l-3";
export var horizontalContainer = "_7l-7";
export var sm = "_7l-5";
export var switch0 = "_7l-2";
export var switchDisabled = "_7l-8";
export var switchEnabled = "_7l-1";
export var textSwitchContainer = "_7l-9";
export var textSwitchOption = "_7l-a";
export var textSwitchOptionSelected = "_7l-b";
export var verticalContainer = "_7l-6";
export var xs = "_7l-4";